// extracted by mini-css-extract-plugin
export var boxItems = "_9k-1";
export var boxItemsLg = "_9k-2";
export var button = "_9k-7";
export var buttonHoverless = "_9k-9";
export var buttonLg = "_9k-8";
export var filterGroupBox = "_9k-0";
export var icon = "_9k-3";
export var iconSecondary = "_9k-6";
export var iconWrapper = "_9k-4";
export var iconWrapperLg = "_9k-5";
export var truncatedLabel = "_9k-a";